import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  respostas: {}
};

const formularioRespostaProcessoSlice = createSlice({
  name: 'formularioRespostaProcesso',
  initialState,
  reducers: {
    carregarFormularioRespostaProcesso: (state, action) => {
      const { idProcesso, idSolicitacao, resposta } = action.payload;
      const key = `${idProcesso}-${idSolicitacao}`;
      state.respostas[key] = resposta;
    },
    limparFormularioRespostaProcesso: (state, action) => {
      const { idProcesso, idSolicitacao } = action.payload;
      const key = `${idProcesso}-${idSolicitacao}`;
      delete state.respostas[key];
    },
  },
});

export const {
  carregarFormularioRespostaProcesso,
  limparFormularioRespostaProcesso,
} = formularioRespostaProcessoSlice.actions;

export default formularioRespostaProcessoSlice.reducer;
